import { Routes } from '@angular/router';
import { freshBuildGuard } from './services/app-version.service';
import {
  authGuard,
  onboardedGuard,
  onboardingGuard,
  businessManagerGuard,
  clinicalGuard,
  doctorGuard,
  invoicingGuard,
  teleconsultaGuard,
  membershipGuard,
  noBusinessGuard,
  platformAdminGuard,
} from './services/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'appointments',
    pathMatch: 'full',
  },
  {
    path: 'patients',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, membershipGuard, clinicalGuard],
    loadComponent: () =>
      import('./components/patients/patients.component').then((m) => m.PatientsComponent),
  },
  {
    path: 'appointments',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, membershipGuard, doctorGuard],
    loadComponent: () =>
      import('./components/appointments/appointments.component').then((m) => m.AppointmentsComponent),
  },
  {
    path: 'medications',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, membershipGuard, clinicalGuard],
    loadComponent: () =>
      import('./components/medications/medications.component').then((m) => m.MedicationsComponent),
  },
  {
    path: 'citas',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, membershipGuard, clinicalGuard],
    loadComponent: () =>
      import('./components/citas/citas.component').then((m) => m.CitasComponent),
  },
  {
    path: 'facturacion',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, membershipGuard, invoicingGuard],
    loadComponent: () =>
      import('./components/facturacion/facturacion.component').then(
        (m) => m.FacturacionComponent
      ),
  },
  {
    path: 'teleconsulta/unirse/:code',
    canActivate: [freshBuildGuard],
    loadComponent: () =>
      import('./components/teleconsulta-join/teleconsulta-join.component').then(
        (m) => m.TeleconsultaJoinComponent
      ),
  },
  {
    path: 'teleconsulta',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, membershipGuard, teleconsultaGuard],
    loadComponent: () =>
      import('./components/teleconsulta/teleconsulta.component').then(
        (m) => m.TeleconsultaComponent
      ),
  },
  {
    path: 'plantillas',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, membershipGuard, clinicalGuard],
    loadComponent: () =>
      import('./components/plantillas/plantillas.component').then(
        (m) => m.PlantillasComponent
      ),
  },
  {
    path: 'registro',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, membershipGuard, clinicalGuard],
    loadComponent: () =>
      import('./components/patient-register/patient-register.component').then(
        (m) => m.PatientRegisterComponent
      ),
  },
  {
    path: 'admin',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, platformAdminGuard],
    loadComponent: () =>
      import('./components/admin/admin.component').then((m) => m.AdminComponent),
  },
  {
    path: 'perfil',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard],
    loadComponent: () =>
      import('./components/perfil/perfil.component').then((m) => m.PerfilComponent),
  },
  {
    path: 'consultorio',
    canActivate: [freshBuildGuard, authGuard, onboardedGuard, membershipGuard, businessManagerGuard],
    loadComponent: () =>
      import('./components/consultorio/consultorio.component').then((m) => m.ConsultorioComponent),
  },
  {
    path: 'invitacion/:token',
    canActivate: [freshBuildGuard],
    loadComponent: () =>
      import('./components/invitacion/invitacion.component').then((m) => m.InvitacionComponent),
  },
  {
    path: 'search',
    canActivate: [freshBuildGuard],
    title: 'Buscar consultorio · Interconsulta',
    loadComponent: () =>
      import('./components/search/search.component').then((m) => m.SearchComponent),
  },
  {
    path: 'login',
    canActivate: [freshBuildGuard],
    loadComponent: () =>
      import('./components/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'signup',
    canActivate: [freshBuildGuard],
    loadComponent: () =>
      import('./components/signup/signup.component').then((m) => m.SignupComponent),
  },
  {
    path: 'verificar-correo',
    canActivate: [freshBuildGuard, authGuard],
    loadComponent: () =>
      import('./components/verify-email/verify-email.component').then(
        (m) => m.VerifyEmailComponent
      ),
  },
  {
    path: 'onboarding',
    canActivate: [freshBuildGuard, onboardingGuard],
    loadComponent: () =>
      import('./components/onboarding/onboarding.component').then((m) => m.OnboardingComponent),
  },
  {
    path: 'no-business',
    canActivate: [freshBuildGuard, authGuard, noBusinessGuard],
    loadComponent: () =>
      import('./components/no-business/no-business.component').then((m) => m.NoBusinessComponent),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
